// extracted by mini-css-extract-plugin
export var productImage = "_om-1";
export var viewLink = "_om-2";
export var wishlistItem = "_om-0";